import axios from 'axios'
import store from '../store'
const debug = require('debug')('xlite-web-client:xliteservice')

const decodedCfg = window.slwCfg ?  JSON.parse(Buffer.from(window.slwCfg, 'base64').toString('utf8')) : undefined
const apiHost = decodedCfg ?  decodedCfg.slwApiHost : process.env.VUE_APP_SLW_API_HOST
const apiPort = decodedCfg ?  decodedCfg.slwApiPort : process.env.VUE_APP_SLW_API_PORT

const apiClient = axios.create({
  baseURL: `https://${apiHost}:${apiPort}/api`,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

const getSafeId = (artId) => {
  return encodeURIComponent(artId).replace(/'/g,"%27").replace(/"/g,"%22")
}

const searchAbortControllers = {}
let mediaSearchAbortControllers

apiClient.interceptors.request.use(
  config => {
    //debug('START_REQUEST')
    if(store.getters.a || config.url.includes('auth')){
      return config
    } else {
      debug('Aborted request to ', config.url)
      const controller = new AbortController()
      const notAuthCfg = {
        ...config,
        signal: controller.signal,
      }
      controller.abort()
      return notAuthCfg
    }
  },
  error => {
    //debug('FINISH_LOADING', error)
    return Promise.reject(error)
  }
)

apiClient.interceptors.response.use(
  response => {
    //debug('FINISH_LOADING', response)
    if(store.getters.a){
      const epoch = Number(response.headers['x-auth-e'])
      if(epoch){
        store.dispatch('setE', epoch)
      }
    }
    return response
  },
  error => {
    //debug('FINISH_LOADING', error)
    return Promise.reject(error)
  }
)


export default {
  getMenu(){
    return apiClient.get('/menu')
  },

  getPersonalData(){
    return apiClient.get('/me/personaldata')
  },

  getTreeNodes(){
    return apiClient.get('/category/tree/?_orderby=catDescription&_orderby=scatDescription')
  },

  getCategories(page = 1, limit = 10, sortField = null, sortOrder = null, excludedCatId = null){
    let excludedCat = ''
    if(excludedCatId && Array.isArray(excludedCatId) && excludedCatId.length){
      excludedCat += '&catId='
      for (let index = 0; index < excludedCatId.length; index++) {
        excludedCat += 'notEquals'
        if(index != excludedCatId.length-1){
          excludedCat += '~'
        }
      }
      excludedCat += '&catId='+excludedCatId.join('~')
      if(excludedCatId.length > 1){
        excludedCat += '&catId=and'
      }
    }

    let orderBy = ''
    if(sortField && sortOrder){
      orderBy += `&_orderby=${sortField}~${sortOrder == 1 ? 'ASC' : 'DESC'}`
    }
    const pageString = page ? `_page=${page}&` : ''
    return apiClient.get(`/category/?${pageString}_limit=${limit}${orderBy}${excludedCat}`)
  },

  getSubcategories(page = 1, limit = 10, sortField = null, sortOrder = null, limitedToCategoryId = null, minimal = false){
    debug('limitedToCategoryId', limitedToCategoryId)
    let orderBy = ''
    if(sortField && sortOrder){
      orderBy += `&_orderby=${sortField}~${sortOrder == 1 ? 'ASC' : 'DESC'}`
    }
    const pageString = page ? `_page=${page}&` : ''

    let limitedToCategory = ''
    if(limitedToCategoryId && Array.isArray(limitedToCategoryId) && limitedToCategoryId.length){
      limitedToCategory += '&catId='
      for (let index = 0; index < limitedToCategoryId.length; index++) {
        limitedToCategory += 'equals'
        if(index != limitedToCategoryId.length-1){
          limitedToCategory += '~'
        }
      }
      limitedToCategory += '&catId='+limitedToCategoryId.join('~')
      if(limitedToCategoryId.length > 1){
        limitedToCategory += '&catId=or'
      }
    }

    const minimalString = minimal ? `_minimal=1&` : ''
    return apiClient.get(`/subcategory/?${pageString}${minimalString}_limit=${limit}${orderBy}${limitedToCategory}`)
  },

  getBrands(page = 1, limit = 10, sortField = null, sortOrder = null, minimal = false){
    let orderBy = ''
    if(sortField && sortOrder){
      orderBy += `&_orderby=${sortField}~${sortOrder == 1 ? 'ASC' : 'DESC'}`
    }
    const pageString = page ? `_page=${page}&` : ''
    const minimalString = minimal ? `_minimal=1&` : ''
    return apiClient.get(`/brand/?${pageString}${minimalString}_limit=${limit}${orderBy}`)
  },

  getCustomers(page = 1, limit = 10, sortField = null, sortOrder = null, isActive = null, isCustomer = null, isSupplier = null){
    let orderBy = ''
    let active = ''
    let customer = ''
    let supplier = ''
    if(sortField && sortOrder){
      orderBy += `&_orderby=${sortField}~${sortOrder == 1 ? 'ASC' : 'DESC'}`
    }
    const pageString = page ? `_page=${page}&` : ''
    if(isActive !== null){
      active = `custIsActive=${isActive ? 'y' : 'n'}&`
    }
    if(isCustomer !== null){
      customer = `custIsCustomer=${isCustomer ? 'y' : 'n'}&`
    }
    if(isSupplier !== null){
      supplier = `custIsSupplier=${isSupplier ? 'y' : 'n'}&`
    }
    return apiClient.get(`/customer/?${pageString}${active}${customer}${supplier}_limit=${limit}${orderBy}`)
  },

  getDepartments(page = 1, limit = 10, sortField = null, sortOrder = null, excludedDepartmentId = null){
    let excludedDepartment = ''
    if(excludedDepartmentId && Array.isArray(excludedDepartmentId) && excludedDepartmentId.length){
      excludedDepartment += '&depId='
      for (let index = 0; index < excludedDepartmentId.length; index++) {
        excludedDepartment += 'notEquals'
        if(index != excludedDepartmentId.length-1){
          excludedDepartment += '~'
        }
      }
      excludedDepartment += '&depId='+excludedDepartmentId.join('~')
      if(excludedDepartmentId.length > 1){
        excludedDepartment += '&depId=and'
      }
    }

    let orderBy = ''
    if(sortField && sortOrder){
      orderBy += `&_orderby=${sortField}~${sortOrder == 1 ? 'ASC' : 'DESC'}`
    }
    const pageString = page ? `_page=${page}&` : ''
    return apiClient.get(`/department/?${pageString}_limit=${limit}${orderBy}${excludedDepartment}`)
  },

  getSubdepartments(page = 1, limit = 10, sortField = null, sortOrder = null, excludedSubdepartmentId = null){
    let excludedSubdepartment = ''
    if(excludedSubdepartmentId && Array.isArray(excludedSubdepartmentId) && excludedSubdepartmentId.length){
      excludedSubdepartment += '&sdepId='
      for (let index = 0; index < excludedSubdepartmentId.length; index++) {
        excludedSubdepartment += 'notEquals'
        if(index != excludedSubdepartmentId.length-1){
          excludedSubdepartment += '~'
        }
      }
      excludedSubdepartment += '&sdepId='+excludedSubdepartmentId.join('~')
      if(excludedSubdepartmentId.length > 1){
        excludedSubdepartment += '&sdepId=and'
      }
    }

    let orderBy = ''
    if(sortField && sortOrder){
      orderBy += `&_orderby=${sortField}~${sortOrder == 1 ? 'ASC' : 'DESC'}`
    }
    const pageString = page ? `_page=${page}&` : ''
    return apiClient.get(`/subdepartment/?${pageString}_limit=${limit}${orderBy}${excludedSubdepartment}`)
  },

  getOperators(page = 1, limit = 10, sortField = null, sortOrder = null){
    let orderBy = ''
    if(sortField && sortOrder){
      orderBy += `&_orderby=${sortField}~${sortOrder == 1 ? 'ASC' : 'DESC'}`
    }
    const pageString = page ? `_page=${page}&` : ''
    return apiClient.get(`/operator/?${pageString}_limit=${limit}${orderBy}`)
  },

  getPrinters(page = 1, limit = 10, sortField = null, sortOrder = null){
    let orderBy = ''
    if(sortField && sortOrder){
      orderBy += `&_orderby=${sortField}~${sortOrder == 1 ? 'ASC' : 'DESC'}`
    }
    const pageString = page ? `_page=${page}&` : ''
    return apiClient.get(`/printer/?${pageString}_limit=${limit}${orderBy}`)
  },

  getArticles(perPage, page, params, excludedArticleId = null, limitedToArticleId = null, isArticleSearch = false, articleSearchKeyword = null) {
    let excludedArticle = ''
    if(excludedArticleId && Array.isArray(excludedArticleId) && excludedArticleId.length){
      excludedArticle += '&artId='
      for (let index = 0; index < excludedArticleId.length; index++) {
        excludedArticle += 'notEquals'
        if(index != excludedArticleId.length-1){
          excludedArticle += '~'
        }
        //excludedArticleId[index] = excludedArticleId[index].replaceAll(',', ';')
      }
      excludedArticle += '&artId='+excludedArticleId.join('~')
      if(excludedArticleId.length > 1){
        excludedArticle += '&artId=and'
      }
    }

    let limitedToArticle = ''
    if(limitedToArticleId && Array.isArray(limitedToArticleId) && limitedToArticleId.length){
      limitedToArticle += '&artId='
      for (let index = 0; index < limitedToArticleId.length; index++) {
        limitedToArticle += 'equals'
        if(index != limitedToArticleId.length-1){
          limitedToArticle += '~'
        }
        //limitedToArticleId[index] = limitedToArticleId[index].replaceAll(',', ';')
      }
      limitedToArticle += '&artId='+limitedToArticleId.join('~')
      if(limitedToArticleId.length > 1){
        limitedToArticle += '&artId=or'
      }
    }

    const validFilters = [
      {key: '_limit', value: perPage},
      {key: '_page', value: page}
    ];
    const paramsObj = JSON.parse(params)
    debug(paramsObj)
    const optionalCols = paramsObj.activeOptionalCols
    const filters = paramsObj.filters
    const filterEntries = Object.entries(filters)
    const sortField = paramsObj.sortField
    const sortOrder = paramsObj.sortOrder
    const selectedCatId = paramsObj.catId
    const selectedSubcatId = paramsObj.subcatId
    const selectedBrandId = paramsObj.brandId
    const selectedSdeptId = paramsObj.sdepartmentId

    if(sortField && sortOrder){
      debug('sortOrder: ', sortOrder)
      validFilters.push({
        key: '_orderby',
        value: `${sortField}~${sortOrder == 1 ? 'ASC' : 'DESC'}`}
      )
    }

    if(selectedCatId){
      /*
      selectedCatId.forEach((element) => {
        validFilters.push({
          key: 'nodeId',
          value: `${element}~cat`
        })
      })
      */
      validFilters.push({
        key: 'catId',
        value: selectedCatId.join('~')
      })
    }
    if(selectedSubcatId){
      /*
      selectedSubcatId.forEach((element) => {
        validFilters.push({
          key: 'nodeId',
          value: `${element}~scat`
        })
      })
      */
      validFilters.push({
        key: 'scatId',
        value: selectedSubcatId.join('~')
      })
    }
    if(selectedBrandId){
      validFilters.push({
        key: 'brandId',
        value: selectedBrandId
      })
    }
    if(selectedSdeptId){
      validFilters.push({
        key: 'sdepartmentId',
        value: selectedSdeptId
      })
    }

    //debug(filters)
    //debug(filterEntries)
    for (const [key, value] of filterEntries) {
      //debug(key, value.matchMode, value.value, value.constraints)
      if(value.value){
        //debug(key)
        // For Sliders
        if(Array.isArray(value.value)){
          validFilters.push({'key': key, 'value': 'in'})
          value.value.forEach((element) => {
            validFilters.push({'key': key, 'value': element})
          })
        } else {
          /*
          // For Price
          if(key == 'artPrice'){
            validFilters.push({'key': key, 'value': value.matchMode})  
            validFilters.push({'key': key, 'value': value.value})  
          } else {
            // For others
            validFilters.push({'key': key, 'value': value.value})
          }
          */
          if(value.matchMode && value.value){
            validFilters.push({'key': key, 'value': value.matchMode})  
            validFilters.push({'key': key, 'value': value.value})
          } else if(!value.matchMode && value.value) {
            validFilters.push({'key': key, 'value': value.value})
          }
        }
      } else if(value.constraints){
        const constraints = value.constraints
        let operators = []
        let values = []
        let logicalOperator = value.operator
        // Handling only a single constraint
        // TODO: handling multiple constraints
        constraints.forEach((element) => {
          operators.push(element.matchMode)
          if(element.value || element.value === 0){
            if(element.matchMode != 'notEmpty' && element.matchMode != 'isEmpty')
            values.push(element.value)
          }
        })
        if(values.length){
          debug(key, operators, values, logicalOperator)
          /*
          if(key == 'artCode'){
            values.forEach((value, index) => {
              values[index] = value.replaceAll(',', ';')
            });
          }
          */     

          if(key != 'catDescription' && key != 'scatDescription' && key != 'artBrand' && key != 'artCustomer' && key != 'artDepartment' && key != 'artSDepartment'){
            validFilters.push({'key': key, 'value': operators.join('~')})
            validFilters.push({'key': key, 'value': values.join('~')})
            if(values.length > 1){
              validFilters.push({'key': key, 'value': logicalOperator})
            }
          } else if(key == 'catDescription' || key == 'scatDescription' || key == 'artBrand' || key == 'artCustomer' || key == 'artDepartment' || key == 'artSDepartment') {
            const iteratedOperators = []
            const filteredValues = []
            values[0].forEach(element => {
              iteratedOperators.push(operators[0])
              if(element.catDescription) filteredValues.push(element.catDescription)
              else if(element.scatDescription) filteredValues.push(element.scatDescription)
              else if(element.brandName) filteredValues.push(element.brandName)
              else if(element.custBizName) filteredValues.push(element.custBizName)
              else if(element.depDescription) filteredValues.push(element.depDescription)
              else if(element.sdepDescription) filteredValues.push(element.sdepDescription)
            })
            if(filteredValues.length){
              validFilters.push({'key': key, 'value': iteratedOperators.join('~')})
              validFilters.push({'key': key, 'value': filteredValues.join('~')})

              if(filteredValues.length > 1){
                validFilters.push({'key': key, 'value': logicalOperator})
              }
            }
          }
        } else if(operators.length && ( operators.includes('notEmpty') ||  operators.includes('isEmpty')) ){
          validFilters.push({'key': key, 'value': operators.join('~')})
        }
        /*
        if(value.constraints[0].value){
          validFilters.push({'key': key, 'value': value.constraints[0].matchMode})
          validFilters.push({'key': key, 'value': value.constraints[0].value})
        }
        */
      }
    }

    if(optionalCols){
      optionalCols.forEach((element) => {
        const isPresent= validFilters.find((filter) =>{
          return filter.key == element.code
        })
        if(!isPresent){
          validFilters.push({'key': element.code, 'value': ''})
        }
      })
    }

    const queryParams = validFilters.map(
                                        (element) => element.key +
                                        (element.value ? '=' : '') +
                                        encodeURIComponent(element.value)
                                        .replace(/'/g,"%27")
                                        .replace(/"/g,"%22"))
                                        .join('&')
    //debug(queryParams)
    //debug(validFilters.map(key => encodeURIComponent(key) + '=' + encodeURIComponent(filters[key])).join('&'))
    //const queryParams = Object.keys(lazyParams).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(lazyParams[k])).join('&');
    //debug(queryParams)
    if(!isArticleSearch){
      return apiClient.get(`/article?` + queryParams + excludedArticle + limitedToArticle)
    } else {
      return apiClient.get(`/article/search/${articleSearchKeyword}?` + queryParams)
    }
  },

  getRecentArticles(){
    return apiClient.get('/article?_orderby=artCreationDate~desc&_limit=30&artCustomer&artDepartment&artSDepartment&artCode')
  },

  getArticle(id, isBarcodeRequest = false) {
    const _isbarcodereq = isBarcodeRequest ? '?_isbarcodereq=1' : ''
    //id = encodeURIComponent(id).replace(/'/g,"%27").replace(/"/g,"%22")
    return apiClient.get(`/article/` + getSafeId(id) + _isbarcodereq)
  },

  getBarcodeArticleId(barcode) {
    barcode = encodeURIComponent(barcode).replace(/'/g,"%27").replace(/"/g,"%22")
    return apiClient.get('/article/barcode/' + barcode)
  },

  getArticleInQrcode(qrcode) {
    qrcode = encodeURIComponent(qrcode).replace(/'/g,"%27").replace(/"/g,"%22")
    return apiClient.get('/article/qrcode/' + qrcode)
  },

  postArticleChecklist(checklist) {
    return apiClient.post(`/article/checklist`, { checklist })
  },

  getCloudinarySignature(params){
    params = {data: params}
    return apiClient.get('/cloudinary_signature', {params: params})
  },

  getCloudinaryStatus(summary = '', nocache = false){
    nocache = nocache ? '?nocache' : ''
    return apiClient.get(`/cloudinary_status/${summary}${nocache}`)
  },

  getDepartmentSales(params){
    let department = ''

    const handler = {
      get(target, prop){
        if(prop === 'operatorLimited'){
          return target[prop] ?? false
        }
        if(prop === 'department'){
          return !target[prop] ? '' : target[prop]
        }
        if(prop === 'operatorId'){
          return !target[prop] ? '' : target[prop].join('~')
        }
        if(prop === 'operator' || prop === 'startDate' || prop === 'endDate' || prop === 'singleDate' || prop === 'logicOperator'){
          return !target[prop] ? null : target[prop]
        }
        if(prop === 'multipleDates' || prop === 'multipleOperators'){
          if(!target[prop]){
            return null
          } else {
            return target[prop].join('~')
          }
        }
      }
    }
    const proxy = new Proxy(params, handler)

    const validFilters = []
    if(proxy.operator) validFilters.push({key: 'documentDate', value: proxy.operator})
    if(proxy.multipleOperators) validFilters.push({key: 'documentDate', value: proxy.multipleOperators})
    if(proxy.startDate) validFilters.push({key: 'documentDate', value: proxy.startDate})
    if(proxy.endDate) validFilters.push({key: 'documentDate', value: proxy.endDate})
    if(proxy.singleDate) validFilters.push({key: 'documentDate', value: proxy.singleDate})
    if(proxy.multipleDates) validFilters.push({key: 'documentDate', value: proxy.multipleDates})
    if(proxy.logicOperator) validFilters.push({key: 'documentDate', value: proxy.logicOperator})
    if(proxy.operatorId) validFilters.push({key: 'operatorId', value: proxy.operatorId})
    if(proxy.department) department = proxy.department
    validFilters.push({key: '_orderby', value: 'departmentDescription~asc'})
    debug('validFilters:', validFilters)

    const queryParams = validFilters.map(
      (element) => element.key +
      (element.value ? '=' : '') +
      (Array.isArray(element.value) ? encodeURIComponent(element.value.join('~')) : encodeURIComponent(element.value))
      .replace(/'/g,"%27")
      .replace(/"/g,"%22"))
      .join('&')
    
    const endpoint = proxy.operatorLimited ? 'operatoranalytics' : 'analytics'
    debug(endpoint)
    return apiClient.get(`${endpoint}/department_sales${department}?${queryParams}`)
  },

  getBrandSales(params){
    let brand = ''

    const handler = {
      get(target, prop){
        if(prop === 'operatorLimited'){
          return target[prop] ?? false
        }
        if(prop === 'brand'){
          return !target[prop] ? '' : target[prop]
        }
        if(prop === 'operatorId'){
          return !target[prop] ? '' : target[prop].join('~')
        }
        if(prop === 'operator' || prop === 'startDate' || prop === 'endDate' || prop === 'singleDate' || prop === 'logicOperator'){
          return !target[prop] ? null : target[prop]
        }
        if(prop === 'multipleDates' || prop === 'multipleOperators'){
          if(!target[prop]){
            return null
          } else {
            return target[prop].join('~')
          }
        }
      }
    }
    const proxy = new Proxy(params, handler)

    const validFilters = []
    if(proxy.operator) validFilters.push({key: 'documentDate', value: proxy.operator})
    if(proxy.multipleOperators) validFilters.push({key: 'documentDate', value: proxy.multipleOperators})
    if(proxy.startDate) validFilters.push({key: 'documentDate', value: proxy.startDate})
    if(proxy.endDate) validFilters.push({key: 'documentDate', value: proxy.endDate})
    if(proxy.singleDate) validFilters.push({key: 'documentDate', value: proxy.singleDate})
    if(proxy.multipleDates) validFilters.push({key: 'documentDate', value: proxy.multipleDates})
    if(proxy.logicOperator) validFilters.push({key: 'documentDate', value: proxy.logicOperator})
    if(proxy.operatorId) validFilters.push({key: 'operatorId', value: proxy.operatorId})
    if(proxy.brand) brand = proxy.brand
    validFilters.push({key: '_orderby', value: 'brandName~asc'})
    debug('validFilters:', validFilters)

    const queryParams = validFilters.map(
      (element) => element.key +
      (element.value ? '=' : '') +
      (Array.isArray(element.value) ? encodeURIComponent(element.value.join('~')) : encodeURIComponent(element.value))
      .replace(/'/g,"%27")
      .replace(/"/g,"%22"))
      .join('&')
    
    const endpoint = proxy.operatorLimited ? 'operatoranalytics' : 'analytics'
    debug(endpoint)
    return apiClient.get(`${endpoint}/brand_sales${brand}?${queryParams}`)
  },

  getDailySalesDepartment(params){
    const handler = {
      get(target, prop){
        if(prop === 'operatorLimited'){
          return target[prop] ?? false
        }
        if(prop === 'department'){
          return !target[prop] ? '' : target[prop]
        }
        if(prop === 'operatorId'){
          return !target[prop] ? '' : target[prop].join('~')
        }
        if(prop === 'operator' || prop === 'startDate' || prop === 'endDate' || prop === 'singleDate' || prop === 'logicOperator'){
          return !target[prop] ? null : target[prop]
        }
        if(prop === 'multipleDates' || prop === 'multipleOperators'){
          if(!target[prop]){
            return null
          } else {
            return target[prop].join('~')
          }
        }
      }
    }
    const proxy = new Proxy(params, handler)

    const validFilters = []
    if(proxy.operator) validFilters.push({key: 'documentDate', value: proxy.operator})
    if(proxy.multipleOperators) validFilters.push({key: 'documentDate', value: proxy.multipleOperators})
    if(proxy.startDate) validFilters.push({key: 'documentDate', value: proxy.startDate})
    if(proxy.endDate) validFilters.push({key: 'documentDate', value: proxy.endDate})
    if(proxy.singleDate) validFilters.push({key: 'documentDate', value: proxy.singleDate})
    if(proxy.multipleDates) validFilters.push({key: 'documentDate', value: proxy.multipleDates})
    if(proxy.logicOperator) validFilters.push({key: 'documentDate', value: proxy.logicOperator})
    if(proxy.operatorId) validFilters.push({key: 'operatorId', value: proxy.operatorId})
    if(proxy.department) validFilters.push({key: 'departmentId', value: proxy.department})
    //validFilters.push({key: '_orderby', value: 'soldTotal~desc'})
    debug('operatorLimited', proxy.operatorLimited)
    
    const queryParams = validFilters.map(
      (element) => element.key +
      (element.value ? '=' : '') +
      (Array.isArray(element.value) ? encodeURIComponent(element.value.join('~')) : encodeURIComponent(element.value))
      .replace(/'/g,"%27")
      .replace(/"/g,"%22"))
      .join('&')

    const endpoint = proxy.operatorLimited ? 'operatoranalytics' : 'analytics'
    debug(endpoint)
    return apiClient.get(`${endpoint}/daily_sales?${queryParams}`)
  },

  getDailySalesBrand(params){
    const handler = {
      get(target, prop){
        if(prop === 'operatorLimited'){
          return target[prop] ?? false
        }
        if(prop === 'brand'){
          return !target[prop] ? '' : target[prop]
        }
        if(prop === 'operatorId'){
          return !target[prop] ? '' : target[prop].join('~')
        }
        if(prop === 'operator' || prop === 'startDate' || prop === 'endDate' || prop === 'singleDate' || prop === 'logicOperator'){
          return !target[prop] ? null : target[prop]
        }
        if(prop === 'multipleDates' || prop === 'multipleOperators'){
          if(!target[prop]){
            return null
          } else {
            return target[prop].join('~')
          }
        }
      }
    }
    const proxy = new Proxy(params, handler)

    const validFilters = []
    if(proxy.operator) validFilters.push({key: 'documentDate', value: proxy.operator})
    if(proxy.multipleOperators) validFilters.push({key: 'documentDate', value: proxy.multipleOperators})
    if(proxy.startDate) validFilters.push({key: 'documentDate', value: proxy.startDate})
    if(proxy.endDate) validFilters.push({key: 'documentDate', value: proxy.endDate})
    if(proxy.singleDate) validFilters.push({key: 'documentDate', value: proxy.singleDate})
    if(proxy.multipleDates) validFilters.push({key: 'documentDate', value: proxy.multipleDates})
    if(proxy.logicOperator) validFilters.push({key: 'documentDate', value: proxy.logicOperator})
    if(proxy.operatorId) validFilters.push({key: 'operatorId', value: proxy.operatorId})
    if(proxy.brand) validFilters.push({key: 'brandId', value: proxy.brand})
    //validFilters.push({key: '_orderby', value: 'soldTotal~desc'})
    debug('operatorLimited', proxy.operatorLimited)
    
    const queryParams = validFilters.map(
      (element) => element.key +
      (element.value ? '=' : '') +
      (Array.isArray(element.value) ? encodeURIComponent(element.value.join('~')) : encodeURIComponent(element.value))
      .replace(/'/g,"%27")
      .replace(/"/g,"%22"))
      .join('&')

    const endpoint = proxy.operatorLimited ? 'operatoranalytics' : 'analytics'
    debug(endpoint)
    return apiClient.get(`${endpoint}/daily_sales_brand?${queryParams}`)
  },

  getYearMonthCompare(yearsList = [], operatorsList = [], operatorLimited, _semester){
    const semester = _semester ? 1 : 0
    const years = !yearsList.length ? '' : `?years=${yearsList.join('~')}&operatorId=${operatorsList.join('~')}&semester=${semester}`
    const endpoint = operatorLimited ? 'operatoranalytics' : 'analytics'
    return apiClient.get(`${endpoint}/year_month_compare${years}`)
  },

  getDayMonthYearProfit(operatorLimited = false){
    const endpoint = operatorLimited ? 'operatoranalytics' : 'analytics'
    return apiClient.get(`${endpoint}/day_month_year_profit`)
  },

  patchFixArticleDefaultMedia(artId){
    const safeArtId = getSafeId(artId)
    return apiClient.patch(`/article/${safeArtId}/fixdefaultmedia`)
  },

  /*
  postArticleMedia(artId, assetId, publicId, version, format, extraArticleId){
    //const safeArtId = encodeURIComponent(artId).replace(/'/g,"%27").replace(/"/g,"%22")
    const safeArtId = getSafeId(artId)
    return apiClient.post(`/article/${safeArtId}/media`, {
      artId: artId,
      publicId: publicId,
      assetId: assetId,
      version: version,
      format: format,
      extraArticleId: extraArticleId
    })
  },
  */

  postArticleMedia(artId, mediaList, extraArticleId){
    const safeArtId = getSafeId(artId)
    return apiClient.post(`/article/${safeArtId}/media`, {
      mediaList,
      extraArticleId: extraArticleId ? extraArticleId : []
    })
  },

  postMedia(assetId, publicId, version, format){
    return apiClient.post(`/media`, {
      publicId: publicId,
      assetId: assetId,
      version: version,
      format: format
    })
  },

  postPrintQrcode(printerId, printContent){
    return apiClient.post(`/printer/qrcode`, {
      printerId,
      printContent
    })
  },

  getArticleMedia(artId){
    //const safeArtId = encodeURIComponent(artId).replace(/'/g,"%27").replace(/"/g,"%22")
    const safeArtId = getSafeId(artId)
    return apiClient.get(`/article/${safeArtId}/media/`)
  },

  getMediaArticle(mediaId){
    return apiClient.get(`/media/${mediaId}/article/`)
  },

  getMedia(page = 1, limit = 10, sortField = null, sortOrder = null, excludedMediaId = null, limitedToMediatagId = null){
    let excludedMedia = ''
    if(excludedMediaId && Array.isArray(excludedMediaId) && excludedMediaId.length){
      excludedMedia += '&mediaId='
      for (let index = 0; index < excludedMediaId.length; index++) {
        excludedMedia += 'notEquals'
        if(index != excludedMediaId.length-1){
          excludedMedia += '~'
        }
      }
      excludedMedia += '&mediaId='+excludedMediaId.join('~')
      if(excludedMediaId.length > 1){
        excludedMedia += '&mediaId=and'
      }
    }

    const limitedToMediatag = limitedToMediatagId ? `&tagId=${limitedToMediatagId}` : ''

    let orderBy = ''
    if(sortField && sortOrder){
      orderBy += `&_orderby=${sortField}~${sortOrder == 1 ? 'ASC' : 'DESC'}`
    }
    return apiClient.get(`/media/?_page=${page}&_limit=${limit}${orderBy}${excludedMedia}${limitedToMediatag}`)
  },

  getMediatag(page = 1, limit = 10, sortField = null, sortOrder = null, minimal = false){
    let orderBy = ''
    if(sortField && sortOrder){
      orderBy += `&_orderby=${sortField}~${sortOrder == 1 ? 'ASC' : 'DESC'}`
    }
    const pageString = page ? `_page=${page}&` : ''
    const minimalString = minimal ? `_minimal=1&` : ''
    return apiClient.get(`/mediatag/?${pageString}${minimalString}_limit=${limit}${orderBy}`)
  },

  postMediatag(mediatagArray){
    return apiClient.post(`/mediatag`, mediatagArray)
  },

  destroyMediatag(tagId){
    let tagIds = tagId
    if(Array.isArray(tagId)){
      tagIds = tagIds.join('~')
    }
    return apiClient.delete(`/mediatag/${tagIds}`)
  },

  editMediatag(mediatagId, newValue){
    return apiClient.patch(`/mediatag/${mediatagId}`, {
      "mediatagContent": newValue
    })
  },

  getMediaMediatag(mediaIds){
    return apiClient.get(`/media/${mediaIds.join('~')}/mediatag`)
  },

  searchMedia(keyword, page = 1, limit = 10, sortField = null, sortOrder = null, excludedMediaId = null){
    const safeKeyword = encodeURIComponent(keyword).replace(/'/g,"%27").replace(/"/g,"%22")

    let excludedMedia = ''
    if(excludedMediaId && Array.isArray(excludedMediaId) && excludedMediaId.length){
      excludedMedia += '&_excludedmediaid='+excludedMediaId.join('~')
    }

    let orderBy = ''
    if(sortField && sortOrder){
      orderBy += `&_orderby=${sortField}~${sortOrder == 1 ? 'ASC' : 'DESC'}`
    }
    let abortController = mediaSearchAbortControllers
    if(abortController){
      abortController.abort()
    }
    mediaSearchAbortControllers = new AbortController()
    abortController = mediaSearchAbortControllers

    return apiClient.get(
        `/media/search/${safeKeyword}?_page=${page}&_limit=${limit}${orderBy}${excludedMedia}`,
        {
          signal: abortController.signal
        }
      )
  },

  removeArticleMedia(artId, mediaId){
    //const safeArtId = encodeURIComponent(artId).replace(/'/g,"%27").replace(/"/g,"%22")
    const safeArtId = getSafeId(artId)
    return apiClient.delete(`/article/${safeArtId}/media/${mediaId}`)
  },

  removeArticlesFromMedia(mediaId, articleIdArray){
    return apiClient.delete(`/media/${mediaId}/article`,
    {
      data: {
        "articleList": articleIdArray
      }
    })
  },

  removeMediaFromMediatag(mediatagId, mediaIdArray){
    return apiClient.delete(`/mediatag/${mediatagId}/media`,
    {
      data: {
        "mediaList": mediaIdArray
      }
    })
  },

  putMediaInMediatag(mediatagId, mediaIdArray, toBeCreatedMediaTags){
    return apiClient.patch(`/mediatag/${mediatagId}/media`, {
      "mediaList": mediaIdArray,
      "newTagList": toBeCreatedMediaTags
    })
  },

  destroyMedia(mediaId){
    let mediaIds = mediaId
    if(Array.isArray(mediaId)){
      mediaIds = mediaIds.join('~')
    }
    return apiClient.delete(`/media/${mediaIds}`)
  },

  putImageDefault(artId, mediaId){
    //const safeArtId = encodeURIComponent(artId).replace(/'/g,"%27").replace(/"/g,"%22")
    const safeArtId = getSafeId(artId)
    return apiClient.patch(`/article/${safeArtId}/media/${mediaId}/default`)
  },

  putMediaInArticle(artId, mediaIdArray, extraArticleId){
    //const safeArtId = encodeURIComponent(artId).replace(/'/g,"%27").replace(/"/g,"%22")
    const safeArtId = getSafeId(artId)
    return apiClient.patch(`/article/${safeArtId}/media`, {
      mediaList: mediaIdArray,
      extraArticleId: extraArticleId
    })
  },

  putArticleInMedia(mediaId, articleIdArray){
    /*
    const safeArticleIdArray = []
    articleIdArray.forEach(element => {
      //safeArticleIdArray.push(encodeURIComponent(element).replace(/'/g,"%27").replace(/"/g,"%22"))
      safeArticleIdArray.push(getSafeId(element))
    });
    */

    return apiClient.patch(`/media/${mediaId}/article`, {
      "articleList": articleIdArray
    })
  },

  authenticate(username, password, loginToken = null){
    if(loginToken){
      return apiClient.post(`auth/login/${loginToken}`)
    } else {
      return apiClient.post(`auth/login`, {
        "username": username,
        "password": password
      })
    }
  },

  tokenMatch(token){
    return apiClient.get(`auth/tokenmatch/${token}`)
  },

  operatorInfo(){
    return apiClient.get(`auth`)
  },

  operatorSessions(){
    return apiClient.get(`auth/getsessions`)
  },

  terminateSession(sessionRef){
    return apiClient.delete(`auth/st/${sessionRef}`)
  },

  logout(){
    return apiClient.post(`auth/logout`)
  },

  search(keyword, entity, page = 1, limit = 3, sortField = null, sortOrder = null) {
    const safeKeyword = encodeURIComponent(keyword).replace(/'/g,"%27").replace(/"/g,"%22")
    let orderBy = ''
    if(sortField && sortOrder){
      orderBy += `&_orderby=${sortField}~${sortOrder == 1 ? 'ASC' : 'DESC'}`
    }

    let abortController = searchAbortControllers[entity]
    if(abortController){
      abortController.abort()
    }
    searchAbortControllers[entity] = new AbortController()
    abortController = searchAbortControllers[entity]

    let searchPromise = new Promise((resolve, reject) => {
      apiClient.get(
        `/${entity}/search/${safeKeyword}?_page=${page}&_limit=${limit}${orderBy}`,
        {
          signal: abortController.signal
        }
      )
      .then((resp) => {
        resolve({ entity: entity, items: resp.data, totalCount: resp.headers['x-total-count'] })
      })
      .catch((error) => {
        if (axios.isCancel(error)) {
          debug(`Stale request: ${error.message}`);
        } else {
          reject({entity: entity, error: error});
        }
      });
    })  

    return searchPromise;      
  }
}
